import { render, staticRenderFns } from "./InfoCardElement.vue?vue&type=template&id=316791ff&scoped=true&"
import script from "./InfoCardElement.vue?vue&type=script&lang=js&"
export * from "./InfoCardElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316791ff",
  null
  
)

export default component.exports